export const STATUS_META = {
  draft:    { label: 'Draft',    bg: '#f2f5f6', color: '#607d8b' },
  approved: { label: 'Approved', bg: '#e8f5e9', color: '#2e7d32' },
  paid:     { label: 'Paid',     bg: '#d0f0e0', color: '#1a5e35' },
  voided:   { label: 'Voided',   bg: '#fff3d9', color: '#8c5b00' },
}

export const STATUS_OPTIONS = [
  { value: '',         label: 'All' },
  { value: 'draft',    label: 'Draft' },
  { value: 'approved', label: 'Approved' },
  { value: 'paid',     label: 'Paid' },
  { value: 'voided',   label: 'Voided' },
]
